<template>
  <el-dialog
    width="600px"
    title="保存数据集"
    append-to-body
    :visible.sync="showAuth"
    @close="handleClose"
  >
    <el-form ref="authForm" class="authForm" :rules="authRules" :model="authForm" label-width="100px" size="small">
      <el-form-item label="数据集类型" label-width="100px" prop="applyType">
        <el-select v-model="authForm.applyType" placeholder="请选择数据集类型" style="width: 100%;">
          <el-option :label="item.name" :value="item.value" :key="index" v-for="(item, index) in typeList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="授权客户" prop="orgIds" v-if="authForm.applyType == 'team' || authForm.applyType == 'personal' || authForm.applyType == 'other' || authForm.applyType == 'testProject'">
        <!-- <el-select v-model="authForm.orgIds" multiple filterable placeholder="请选择授权客户" style="width: 100%;">
          <el-option :label="item.name" :value="item.id" :key="index" v-for="(item, index) in userData"></el-option>
        </el-select> -->
        <el-cascader
          filterable
          style="width: 100%;"
          v-model="authForm.orgIds"
          placeholder="请选择授权客户"
          :props="userProps"
          :options="userData"
          ></el-cascader>
      </el-form-item>
    </el-form>
    <div slot="footer" >
      <el-button size="mini" @click="handleClose" >取消 </el-button>
      <el-button type="primary" size="mini" @click="saveAuth()" >保存 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as API_Ques from "@/api/dataAccess/questionnaire";
import * as API_DataModel from '@/api/datamodel/index'
const sysList = [
  { name: '系统看板', value: 'system' },
  { name: '设备模型', value: 'device' },
  { name: '团队模型', value: 'team' },
  { name: '运动员模型', value: 'personal' },
  { name: '测试项目模型', value: 'testProject' },
  { name: '其他模型', value: 'other' },
]
const otherList = [
  { name: '团队模型', value: 'team' },
  { name: '运动员模型', value: 'personal' },
  { name: '测试项目模型', value: 'testProject' },
  { name: '其他模型', value: 'other' },
]
export default {
  data() {
    return {
      userRole: '',
      authRules: {
        applyType: [{ required: true, message: "请选择数据集类型" }],
        // orgIds: [{ required: true, message: "请选择授权客户", type: 'array' }],
      },
      authForm: {
        applyType: null,
        orgIds: []
      },
      showAuth: false,
      typeList: [
        { name: '团队模型', value: 'team' },
        { name: '运动员模型', value: 'personal' },
        { name: '其他模型', value: 'other' },
      ],
      userData: [],
      userProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default: (res) => {
      }
    },
    params: {
      type: Object,
      default: (res) => {
      }
    },
  },
  watch: {
    show: function(val) {
      // console.log(val);
      this.showAuth = val
      if(val) this.authForm = this.params
    }
  },
  mounted() {
    this.userRole = this.$store.state.user.roles.length && this.$store.state.user.roles[0].name || ''
    this.typeList = this.userRole == 'ADMIN' ? sysList : otherList
    this.userRole == 'ADMIN' ? this.getOrgList() : this.getGroupTree()
  },
  methods: {
    getGroupTree() {
      API_Ques.getGroupTree().then(res => {
        if (res.code == 200) {
          console.log(res.data);
          this.userData = res.data
        }
      })
    },
    getOrgList() {
      API_DataModel.getOrgList().then(res => {
          if (res.success) {
            // return {...item,item.id:item.orgId}
            this.userData = res.data.map(item => {
            return { ...item, id: item.orgId }
          })
        }
      })
    },
    handleClose() {
      // this.showAuth = false,
      this.$emit('closeAuth')
    },
    saveAuth() {
      this.$refs['authForm'].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.authForm))
          let orgIds = params.orgIds
          console.log(orgIds);
          let arr = []
          if(orgIds.length) {
            for (let i = 0; i < orgIds.length; i++) {
              const ele = orgIds[i];
              console.log(ele[ele.length -1]);
              arr.push(ele[ele.length -1])
            }
          }
          console.log(arr);
          params.targetIds = arr
          params.authTargetType =  this.userRole == 'ADMIN' ? 'org' : 'group'
          delete params.orgIds
          this.$emit('update', params)
          // this.showAuth = false
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: 'error',
            showClose: true
          })
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .authForm ::v-deep .el-cascader__search-input {
    background: unset;
  }
</style>
<!-- el-cascader__search-input -->
